export default "__VITE_ASSET__BuniGaZx__"